export const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
  const tokens = localStorage.getItem('auth_tokens');
  if (!tokens) return {};
  const { id_token } = JSON.parse(tokens);
  return id_token ? { Authorization: `Bearer ${id_token}` } : {};
 };

const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('auth_tokens');
      window.location.href = '/authentiate';
    }

    const error = await response.json();
    throw { ...error, status: response.status };
    
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
};

const client = {
  get: async (endpoint) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      headers: {
        ...getAuthHeader(),
      }
    });
    return handleResponse(response);

  },

  post: async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  put: async (endpoint, data) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeader(),
      },
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  delete: async (endpoint) => {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'DELETE',
      headers: {
        ...getAuthHeader(),
      }
    });
    return handleResponse(response);
  }
};

export default client;
